import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {TaskModel} from "../../models/task.model";

export const TasksChannelActions = createActionGroup({
  source: '[Task/Channel]',
  events: {
    subscribe: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: TaskModel }>(),
  }
});

export const TasksAPiActions = createActionGroup({
  source: '[Task/API]',
  events: {

    //Get Tasks
    getTasks: props<{ taskIds: string[] }>(),
    getTasksSuccess: props<{ tasks: TaskModel[] }>(),
    getTasksFailure: props<{ error: any }>()
  }
});

export const TasksActions = createActionGroup({
  source: '[Task]',
  events: {
    setTasks: props<{ tasks: TaskModel[] }>(),
    // setTask: props<{task: TaskModel}>(),
    removeTasks: props<{ ids: string[] }>(),
    removeAll: emptyProps()
  }
});

